// vim: set ts=2 sts=2 sw=2 et:
//
// Render (plan gratuito) apaga el server en vivo tras 15 minutos sin tráfico entrante, y en una pausa del
// torneo nadie le manda nada. Mientras esta PC tenga la Tarima en vivo activa contra un server en la nube,
// le pega a /health cada pocos minutos para que no se duerma. No evita los reinicios que Render puede hacer
// cuando quiera: de esos se recuperan solas las pantallas, que reconectan.

import React from "react";
import { useSelector } from "react-redux";

import type { GlobalState } from "../../types/stateTypes";
import { getPlatformLiveBridgeConfig, isRemotePlatformLiveBridge } from "./platformLiveBridgeClient";
import type { PlatformLiveProfile } from "./platformLiveProfile";

/** Bien por debajo de los 15 minutos de Render, aun con el navegador frenando timers de pestañas ocultas. */
export const PLATFORM_LIVE_KEEPALIVE_INTERVAL_MS = 5 * 60_000;

// Mismo path que PLATFORM_LIVE_BRIDGE_HEALTH_PATH del server (platformLiveBridge.ts usa node:http y no se
// puede importar desde el navegador). Responde sin chequear origen ni token.
const HEALTH_PATH = "/health";

const keepAliveUrl = (profile: PlatformLiveProfile | null): string | null => {
  if (profile === null) return null;
  const bridge = getPlatformLiveBridgeConfig(profile.bridgeProviderId);
  if (bridge === null || !isRemotePlatformLiveBridge(bridge)) return null;
  try {
    return new URL(HEALTH_PATH, bridge.url).toString();
  } catch (_error) {
    return null;
  }
};

const PlatformLiveKeepAlive = () => {
  const activeProfile = useSelector((state: GlobalState) => state.wrpfLive.activeProfile);
  const url = keepAliveUrl(activeProfile);

  React.useEffect(() => {
    if (url === null || typeof window.fetch !== "function") return undefined;
    // `no-cors`: no hace falta leer la respuesta, solo que el request llegue.
    const ping = () => {
      window.fetch(url, { mode: "no-cors", cache: "no-store" }).catch(() => undefined);
    };
    const timer = window.setInterval(ping, PLATFORM_LIVE_KEEPALIVE_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [url]);

  return null;
};

export default PlatformLiveKeepAlive;
